import { useLogin } from '@bnnvara/accounts';
import { useContext } from 'react';

import { FollowBrandContext } from './FollowBrandContext';

export function useIsFollowedByUser(brandId) {
  const { isBrandFollowedByUser, toggleFollowBrand } =
    useContext(FollowBrandContext);
  const { login, status, isLoggedIn } = useLogin();

  function isFollowedByUser() {
    if (status !== 'success' && status !== 'idle') {
      return undefined;
    }

    if (isLoggedIn) {
      return isBrandFollowedByUser(brandId);
    }

    return false;
  }

  /**
   * This function returns:
   * - `null` when not logged in
   * - `true` when following
   * - `false` when unfollowing
   */
  async function toggle() {
    if (!isLoggedIn) {
      login();

      return null;
    }

    return toggleFollowBrand(brandId);
  }

  return {
    isFollowedByUser: isFollowedByUser(),
    toggle,
  };
}
